import React, { useState,useMemo, useEffect } from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';
import {  useNavigate } from 'react-router-dom';
import {
  Table,
  Form,
  Dropdown,
  ButtonGroup,
  Button,
  InputGroup,
} from 'react-bootstrap';
import { list_channels } from '../../../utils/crm_services';
import { currencyFormatter } from '../../../utils/services';

import { list_all_strategies_history } from '../../../utils/talent_services';
import CountryPieChart from '../crm/charts/CountryPieChart';
function Channels  ({user_id, permission, usr_type}) {
    // --- Estado de filtros/orden/columnas ---
    const navigate = useNavigate();   
    const [searchTerm, setSearchTerm] = useState('');
    const [sortConfig, setSortConfig] = useState({ key: 'dollar_amount', dir: 'desc' });
    const [initialRows, setinitialRows] = useState([ ]);
    const token = localStorage.getItem("token");
    useEffect(() => {
          fetchloadStrategies(token);
        }, [token]); 

      async function fetchloadStrategies(token) {
                const channelData = await list_all_strategies_history(token);
                if (channelData==="INVALID"){
                    navigate("/");
                }
                else{
                  if(channelData!=null){
                  const tempCH = channelData.map((celement, index) => {
                    return {
                      trello_card_id: celement.trello_card_id,
                      title: celement.title,
                      total_cost: celement.total_cost,
                      opportunity_count: celement.opportunity_count,
                      opportunity_percentage: celement.opportunity_percentage,
                      index:index
                    };
                  });
                  setinitialRows(tempCH);
                }
                }
          }

    // --- Filtrado + ordenamiento memoizados ---
    const rows = useMemo(() => {
      let result = initialRows;
  
      if (searchTerm) {
        const term = searchTerm.toLowerCase();
        result = result.filter((r) =>
          Object.values(r).some((v) => String(v).toLowerCase().includes(term))
        );
      }
      result = [...result].sort((a, b) => {
        let aVal = a[sortConfig.key];
        let bVal = b[sortConfig.key];

        console.log("ORDERBY " + sortConfig.key);
        if (sortConfig.key === 'opportunity_count' || sortConfig.key === 'total_cost' || sortConfig.key === 'opportunity_percentage' ){
            aVal = parseFloat(aVal);
            bVal = parseFloat(bVal);
        }
        
        if (aVal === bVal) return 0;
        const order = aVal > bVal ? 1 : -1;
        return sortConfig.dir === 'asc' ? order : -order;
      });

        
  
      return result;
    }, [searchTerm, sortConfig, initialRows]);


     const { chartLabels, chartDataValues } = useMemo(() => {
                             // 1. Contar las ocurrencias de cada país
                  // AHORA: Sumando el moneyAmount
                        const countryTotals = rows.reduce((acc, current) => {
                          const criterio = current.opportunity_count;
                          // En lugar de sumar 1, sumamos el `moneyAmount` del elemento actual.
                          // Usamos Number() para asegurar que el valor sea numérico.
                          const amount = Number(current.total_cost) || 0;
                          acc[criterio] = (acc[criterio] || 0) + amount; // <-- La línea clave del cambio
                          
                          return acc;
              
                        }, {});

        return {
            chartLabels: Object.keys(countryTotals),
            chartDataValues: Object.values(countryTotals)
        };
  }, [rows]);
  
    // --- Handlers ---
    const toggleSort = (key) => {
      setSortConfig((prev) => {
        if (prev.key === key) {
          return { key, dir: prev.dir === 'asc' ? 'desc' : 'asc' };
        }
        return { key, dir: 'asc' };
      });
    };
  
 
    // Icono flecha ↑↓
    const SortIcon = ({ col }) =>
      sortConfig.key === col ? (sortConfig.dir === 'asc' ? '↑' : '↓') : '↕';


    // ---------- UI ----------
    return (
      
      <div className="container py-4">





        <h1 className="mb-4 fw-bold">TOMi Estrategies</h1>

    <div className="col-lg-5">
      
      {/* Tarjeta 3: Gráfico Circular */}
      {/* h-100 hace que la tarjeta ocupe toda la altura disponible */}
      <div className="card shadow-sm h-100">
        <div className="card-body d-flex flex-column">
           <h5 className="card-title mb-3 text-center">Strategy by Opportunities</h5>
           {/* El gráfico ocupará el espacio restante */}
           <div className="flex-grow-1" style={{ minHeight: '250px' }}>
             <CountryPieChart title="Strategy by Opportunities" labels={chartLabels} dataValues={chartDataValues} />
           </div>
        </div>
      </div>

    </div>
  
        {/* Barra de búsqueda + menús */}
        <div className="d-flex gap-2 mb-3 flex-wrap">
          <InputGroup className="flex-grow-1" style={{ maxWidth: 320 }}>
            <Form.Control
              placeholder="Search all columns..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className='toolbar-control'
            />
          </InputGroup>
        </div>

  
        {/* Tabla */}
        <Table hover responsive className="align-middle">
          <thead className="table-light">
            <tr >
         
             
                <th onClick={() => toggleSort('channelName')} role="button">
                  Name <SortIcon col="channelName" />
                </th>
           
                <th onClick={() => toggleSort('total_cost')} role="button">
                  Costo <SortIcon col="total_cost" />
                </th>
             
                <th onClick={() => toggleSort('opportunity_count')} role="button">
                  Leads <SortIcon col="opportunity_count" />
                </th>

                <th onClick={() => toggleSort('opportunity_percentage')} role="button">
                  % Charged <SortIcon col="opportunity_percentage" />
                </th>
            
            </tr>
          </thead>
          <tbody>
            {rows.map((row) => (
              <tr key={row.id} onClick={() => navigate(`/strategypage?cardid=${row.trello_card_id}`)}>
     
                <td>{row.title}</td>
                <td>{currencyFormatter.format(row.total_cost)}</td>
                <td>{row.opportunity_count}</td>
                <td style={row.opportunity_percentage > 1 ? { color: 'red', fontWeight: 'bold' } : {}}>
                  {row.opportunity_percentage*100}%</td>
              </tr>
            ))}
            {rows.length === 0 && (
              <tr>
                <td colSpan="10" className="text-center py-4">
                  No results
                </td>
              </tr>
            )}
          </tbody>
        </Table>
      </div>
    );
};

export default Channels;
